export const ANONYMOUS_GUEST_ID_PLACEHOLDER_PREFIX = 'anonymous_'
export const JUMPSTART_GUEST_INTERVAL = 10000
export const JUMPSTART_GUEST_MAX_RETRIES = 5
